import script from "./Official.vue?vue&type=script&setup=true&lang=js"
export * from "./Official.vue?vue&type=script&setup=true&lang=js"

import "./Official.vue?vue&type=style&index=0&id=335c671e&scoped=true&lang=css"

import exportComponent from "D:\\node\\电脑版Windous\\myOfficial\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-335c671e"]])

export default __exports__